/* MUI */
import { Box } from '@mui/material';

/*  React  */
import React from 'react';

/*  Components  */
import CoverPage from '../Components/Containers/CoverPage';
import { ContractBigCalendars } from './internal/ContractBigCalendars';
import { ContractUsersDetailsAppBreakdown } from './internal/ContractUsersDetailsAppBreakdown';
import { ContractsLists } from './internal/ContractsLists';
import { SummaryCard } from './internal/SummaryCard';

export const ContractsReport = ({ reportSetup, reportData }) => {
    if (!reportData) {
        return null;
    }

    const {
        contracts,
        numberContractsConfigured,
        totalContractValue,
        totalMonthlyValue
    } = reportData;

    return (
        <Box
            data-testid="contractsReportMainRender"
            data-trackid="contractsReportMainRender"
            width="100%"
            sx={{ backgroundColor: 'background.contractsReport' }}
        >
            {reportSetup.reportSelections?.contractsContractsCover && (
                <CoverPage reportSetup={reportSetup} />
            )}
            <Box>
                <Box p="24px">
                    <SummaryCard
                        totalNumberOfContracts={numberContractsConfigured}
                        totalContractValue={totalContractValue}
                        totalMonthlyValue={totalMonthlyValue}
                    />
                </Box>
                {reportSetup.reportSelections?.contractsContractsOverview && (
                    <Box px="24px">
                        <ContractBigCalendars
                            contracts={contracts}
                            startDate={reportSetup.startTime}
                        />
                        <ContractsLists contracts={contracts} />
                    </Box>
                )}
                {reportSetup.reportSelections
                    ?.contractsContractsApplicationUserDetails && (
                    <ContractUsersDetailsAppBreakdown contracts={contracts} />
                )}
            </Box>
        </Box>
    );
};
